// Stick Stories — utilitaires responsive
// Chargé avant les JSX. Expose useIsMobile() et SS_PAD globalement.

window.useIsMobile = function() {
  var [isMobile, setIsMobile] = React.useState(function() { return window.innerWidth < 768; });
  React.useEffect(function() {
    var handle = function() { setIsMobile(window.innerWidth < 768); };
    window.addEventListener('resize', handle, { passive: true });
    return function() { window.removeEventListener('resize', handle); };
  }, []);
  return isMobile;
};

// Padding responsive: 56px desktop, 18px mobile
window.SS_PAD = function(mobile) {
  return mobile ? '0 18px' : '0 56px';
};
